import Modal from "../../../../../commons/Modal/Modal";
import UpdateSubUserForm from "./UpdateSubUserForm/UpdateSubUserForm";
import { UpdateSubUserModalProps } from "./UpdateSubUserModal.types";

export default (props: UpdateSubUserModalProps) => {

  return (
    <Modal closeOnClickOutside {...props}>
      <UpdateSubUserForm />
    </Modal>
  )
}